import React, { Component } from 'react';
import Paper from '@material-ui/core/Paper';
import { DeereCachedFetch } from '../../../shared/fetch';
import BundleInfoField from '../FormInputField/BundleInfoField';
import {Row, Checkbox, Table} from '@deere/ux.uxframe-react';
import DocumentRow from '../DocumentRow';
import { SpinnerIcon } from '../../Icon';
import {countryInfo} from '../Constants/constants';
import {FormattedMessage} from 'react-intl';
import {quoteStatusMap} from '../../../mappers/translationMappers';
import PropTypes from 'prop-types';
import {getFinanceProductValue} from '../../../shared/utility';

const styles = {
    dataTable: {
        display: 'flex',
        flexWrap: 'wrap',
        margin: '20px auto',
        width: '90%'
    },
    proposalInfo: {
        marginLeft: '5%'
    },
    spinner: {
        display: 'flex',
        flexDirection: 'column',
        width: '10rem',
        height: '10rem',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '40%',
        marginTop: '10%'
    }
};

export class Proposal extends Component {
  state = {
      expanded: false,
      bundleData: this.props.bundleData, // Bundle Data passed from Select Proposal page at click Create Envelope
      documentList: [],
      pdfData: '',
      pdfFileName: '',
      selectedDocuments: []
  };

  getSelectedDocuments = (checked, docCode, docName, documentSigners) => {
      this.setState((prevState) => ({
          selectedDocuments: checked
              ? [...prevState.selectedDocuments, {
                  code: docCode,
                  description: docName,
                  documentSigners: documentSigners
              }]
              : prevState.selectedDocuments.filter((document) => document.code !== docCode)
      }), () => this.props.getDocumentList(this.state.selectedDocuments));
  };

  async componentDidMount() {
      const promises = [];

      promises.push(
          DeereCachedFetch(
              `/api/quotes/documents/${this.state.bundleData.quoteNumber}`,
              {
                  cacheDuration: 'forever'
              }
          )
      );

      const [documentsForQuote] = await Promise.all(promises);

      const portugalAllowedDocuments = ['PTCONTRA', 'PTAF', 'PTSBM', 'PTWHT'];
      const isPortugal = this.state.bundleData.countryCode === 'PT';

      const filteredDocuments = isPortugal
          ? documentsForQuote.filter((value) => portugalAllowedDocuments.includes(value.letterClass.code))
          : documentsForQuote;

      const documentsJson = [];
      filteredDocuments.map((value) =>
          documentsJson.push({
              isChecked: false,
              code: value.letterClass.code,
              docname: value.letterClass.description,
              signers: value.signers
          })
      );

      this.setState({ documentList: documentsJson });
  }

  render() {
      const countryNameLabel = countryInfo[this.state.bundleData.countryCode].getCountryName();
      return (
          <div>
              <div style={styles.proposalInfo}>
                  <Row className="d-flex mx-auto justify-content-around">
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.BUNDLE'}/>
                          value={this.state.bundleData.bundleNumber}
                      />
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.QUOTE'}/>
                          value={this.state.bundleData.quoteNumber}
                      />
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.ICS_REFERENCE'}/>
                          value={this.state.bundleData.icsID ? this.state.bundleData.icsID : <FormattedMessage id={'labels.NOT_AVAILABLE'} /> }
                      />
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.START_DATE'}/>
                          value={this.state.bundleData.startDate}
                      />
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.MATURITY_DATE'}/>
                          value={this.state.bundleData.maturityDate}
                      />
                  </Row>
                  <br />
                  <Row className="d-flex mx-auto justify-content-around">
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.COUNTRY'}/>
                          value=<FormattedMessage id={countryNameLabel}/>
                      />
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.QUOTE_STATUS'}/>
                          value={this.state.bundleData.alfaCaseStatus && quoteStatusMap[this.state.bundleData.alfaCaseStatus.toUpperCase()]}
                      />
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.PRODUCT'}/>
                          value={getFinanceProductValue(this.state.bundleData.countryCode, this.state.bundleData.financeProduct)}
                      />
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.PRIMARY_CUSTOMER'}/>
                          value={this.state.bundleData.primaryCustomer}
                      />
                      <BundleInfoField
                          label=<FormattedMessage id={'labels.DEALER_REFERENCE'}/>
                          value={this.state.bundleData.dealerReference}
                      />
                  </Row>
              </div>
              <Paper elevation={0} style={styles.dataTable}>
                  {this.state.documentList.length === 0 ? (
                      <div style={styles.spinner}>
                          <SpinnerIcon />
                          <p className="text-sm font-italic">
                              <FormattedMessage id={'labels.FETCHING_DOCUMENTS_FOR'}/> {this.state.bundleData.quoteNumber}
                              ...
                          </p>
                      </div>
                  ) : (
                      <Table hover responsive striped>
                          <caption>
                              <FormattedMessage id={'labels.SELECT_DOCUMENTS'}/>
                          </caption>
                          <thead>
                              <tr>
                                  <th className="text-center" scope="col">
                                      <Checkbox disabled id="checkbox-all" />
                                  </th>
                                  <th scope="col">
                                      <FormattedMessage id={'labels.DOCUMENT_NAME'}/>
                                  </th>
                                  <th className="text-center" scope="col">
                                      <FormattedMessage id={'labels.DOWNLOAD'}/>
                                  </th>
                              </tr>
                          </thead>
                          <tbody>
                              {this.state.documentList.map((document) => (
                                  <DocumentRow
                                      countryCode={this.state.bundleData.countryCode}
                                      documentCode={document.code}
                                      documentName={document.docname}
                                      documentSigners={document.signers}
                                      financeProduct={this.state.bundleData.financeProduct}
                                      getSelected={this.getSelectedDocuments.bind(this)}
                                      key={document.code}
                                      quoteNumber={this.state.bundleData.quoteNumber}
                                  />
                              ))}
                          </tbody>
                      </Table>
                  )}
                  {this.state.documentList.length === 0 ? (
                      ''
                  ) : (
                      <p className="text-muted">
                          {this.state.selectedDocuments.length} <FormattedMessage id={'labels.OF'}/>{' '}
                          {this.state.documentList.length} <FormattedMessage id={'labels.DOCUMENTS_SELECTED'}/>
                      </p>
                  )}
              </Paper>
          </div>
      );
  }
}

Proposal.propTypes = {
    bundleData: PropTypes.array.isRequired,
    getDocumentList: PropTypes.func.isRequired
};
